import { Navigate, useParams } from "react-router";
import { useSearchParams } from "react-router-dom";

import { useQuery } from "@tanstack/react-query";

import { initUseQuery } from "simplydo/core/query";
import { Loader } from "simplydo/react/ui/loader";

import api from "api";

import PageLoadError from "components/lib/PageLoadError";

export const CalendarRedirect = () => {
  const { calendarId = "", "*": restPath } = useParams<{
    calendarId: string;
    "*": string;
  }>();
  const [searchParams] = useSearchParams();

  const calendarQuery = useQuery(
    initUseQuery(api.calendars.get, [calendarId], { isEnabled: !!calendarId }),
  );

  const forType = calendarQuery.data?.calendar?.forType || "";
  const forId = calendarQuery.data?.calendar?.forId || "";

  if (forType === "group") {
    const eventSuffix = restPath ? `/${restPath}` : "";
    return (
      <Navigate
        replace
        to={`/groups/${forId}/calendars/${calendarId}${eventSuffix}?${searchParams.toString()}`}
      />
    );
  }

  if (calendarQuery.isLoading) {
    return <Loader />;
  }

  return (
    <PageLoadError
      title="Calendar not found"
      message="The calendar you are looking for does not exist."
    />
  );
};
